import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse, HttpResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {throwError, Observable, BehaviorSubject} from 'rxjs';
import {tap, switchMap, catchError, filter, take} from 'rxjs/operators';
import {AuthService} from './services/auth/auth.service';
import {Router} from '@angular/router';

@Injectable()
export class ProjectHttpInterceptor implements HttpInterceptor {
  private token = '';
  private refreshTokenInProgress = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(private authService: AuthService, private router: Router) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    this.token = localStorage.getItem('at');
    let request = req;

    if (this.token) {
      // Se verifica vigencia del token antes de que caduque y se refresca
      const porExpirar = this.authService.verificarAntesVencimientoToken();
      request = req.clone({
        setHeaders: {
          authorization: `Bearer ${this.token}`
        }
      });

      if (request.url.indexOf('/auth/refresh', 0) > 0 || request.url.indexOf('/auth/logout', 0) > 0 ||
        request.url.indexOf('/catalogos/registro', 0) > 0) {
        return next.handle(request).pipe(
          catchError((err: HttpErrorResponse) => {
            return throwError(err);
          })
        );
      } else {
        if (porExpirar) {
          if (this.refreshTokenInProgress) {
            return this.refreshTokenSubject.pipe(
              filter(result => result !== null),
              take(1),
              switchMap(() => next.handle(this.injectToken(request)))
            );
          } else {
            this.refreshTokenInProgress = true;

            // Set the refreshTokenSubject to null so that subsequent API calls will wait until the new token has been retrieved
            this.refreshTokenSubject.next(null);
            return this.refreshAccessToken().pipe(
              switchMap((success: boolean) => {
                this.refreshTokenSubject.next(success);
                this.refreshTokenInProgress = false;
                return next.handle(this.injectToken(request));
              })
            );
          }
        } else {
          return next.handle(request).pipe(
            catchError((err: HttpErrorResponse) => {
              return throwError(err);
            })
          );
        }
      }
    } else {
      return next.handle(request).pipe(
          tap(evt => {
            if (evt instanceof HttpResponse) {
              if ( evt.body && !evt.body.success){
                if ( evt.body.data.code === 43) {
                  this.router.navigate(['/auth/login'], {queryParams: {skipUnsavedChangesGuard: true}});
                }
              }
            }
        }),
        catchError((err: HttpErrorResponse) => {
          return throwError(err);
        })
      );
    }
  }

  private refreshAccessToken(): Observable<any> {
    return this.authService.refreshToken();
  }

  private injectToken(request: HttpRequest<any>): any {
    const token: string = localStorage.getItem('at');
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }
}
